import { prettyPrintValue } from "@common/utils/string";
import { HEALTH_TO_HUMAN_WORDS } from "./types";

export function getCopyFromHealth(health: string): string {
  const copy = HEALTH_TO_HUMAN_WORDS[health];
  if (!copy) {
    console.warn(`Missing health status: ${health}`);
  }

  return copy || prettyPrintValue(health);
}
